module.exports = __webpack_public_path__ + "media/fonts/PPNeueMontreal-Book-3b3eda24.otf";